import mixpanel from "./mixpanel";
import console from "./console";

export default process.env.NEXT_PUBLIC_MIXPANEL_TOKEN
  ? mixpanel(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN as string)
  : console();
